import type { CSSObject } from '@emotion/react';
import type { Theme } from '@mui/material';
import { tss } from 'tss-react/mui';

import {
  SIDEBAR_WIDTH_COLLAPSED,
  SIDEBAR_WIDTH_EXPANDED
} from '@/constants/sidebar.constants';

const closedMixin = (theme: Theme): CSSObject => ({
  transition: theme.transitions.create(['width', 'min-width'], {
    duration: theme.transitions.duration.leavingScreen,
    easing: theme.transitions.easing.sharp
  }),
  width: SIDEBAR_WIDTH_COLLAPSED
});

const openedMixin = (theme: Theme): CSSObject => ({
  overflowX: 'hidden',
  transition: theme.transitions.create(['width', 'min-width'], {
    duration: theme.transitions.duration.enteringScreen,
    easing: theme.transitions.easing.sharp
  }),
  width: SIDEBAR_WIDTH_EXPANDED
});

const useStyles = tss
  .withParams<{
    isLayoutMobile: boolean;
    isSidebarExpanded: boolean;
  }>()
  .create(({ theme, isLayoutMobile, isSidebarExpanded }) => ({
    content: {
      display: 'flex',
      height: '100vh',
      width: '100%'
    },
    contentOuter: {
      width: '100%',
      overflow: 'auto'
    },
    contentInner: {
      overflow: 'hidden',
      height: '100%'
    },
    contentSpacer: {
      ...(!isLayoutMobile && {
        minWidth: isSidebarExpanded
          ? SIDEBAR_WIDTH_EXPANDED
          : SIDEBAR_WIDTH_COLLAPSED,
        ...(isSidebarExpanded && {
          ...openedMixin(theme),
          '& .MuiDrawer-paper': openedMixin(theme)
        }),
        ...(!isSidebarExpanded && {
          ...closedMixin(theme),
          '& .MuiDrawer-paper': {
            ...closedMixin(theme),
            overflowY: 'visible'
          }
        }),
        width: isSidebarExpanded
          ? SIDEBAR_WIDTH_EXPANDED
          : SIDEBAR_WIDTH_COLLAPSED
      })
    }
  }));

export default useStyles;
